import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FaceIdIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Face ID`} {...props}>
    <Path
      d="M1.455 5.455V2.91c0-.804.65-1.455 1.454-1.455h2.546M10.545 1.455h2.546c.803 0 1.454.651 1.454 1.455v2.545M14.545 10.545v2.546c0 .803-.65 1.454-1.454 1.454h-2.546M5.455 14.545H2.909c-.803 0-1.454-.65-1.454-1.454v-2.546"
      stroke="currentColor"
      strokeWidth={0.91}
      strokeLinecap="round"
      fill="none"
    />
    <Path
      d="M5.818 6.182v1.454M10.182 6.182v1.454M8 6.182V9.09M6.182 10.91c.582.581 1.236.872 1.818.872s1.236-.29 1.818-.873"
      stroke="currentColor"
      strokeWidth={0.91}
      strokeLinecap="round"
      fill="none"
    />
  </Icon>
);
